import useRetrieveAutomationRuns from '@/hooks/api/runs/useRetrieveAutomationRuns.ts';
import { useMemo } from 'react';

type UseLatestAutomationRunOptions = {
  enabled?: boolean;
};

const useLatestAutomationRun = ({ enabled = true }: UseLatestAutomationRunOptions = {}) => {
  const { data: runs, isLoading } = useRetrieveAutomationRuns({ enabled });

  const latestRun = useMemo(() => {
    return runs?.pages && runs?.pages.length > 0 && runs.pages[0].results.length > 0
      ? runs.pages[0].results[0]
      : undefined;
  }, [runs?.pages]);

  return { latestRun, isLoading };
};

export default useLatestAutomationRun;
